module.exports = __webpack_public_path__ + "static/media/sub_menu_makeup_black.f9b1c5ae.png";